// lint rule not applicable to V2 components
/* eslint-disable */
import React from 'react';
import useStyles from './Footer.styles';
import { Footer as FooterType } from '../../contentful';
import useDeviceWidth from '../../hooks/deviceWidth';
import { openLinkCurrentTab } from '../../contentful/utils';
import { trackEvents } from '../../utils/analytics';

export interface Props {
  content: FooterType;
}

/**
 * @deprecated V2 component
 */
const InteractiveQuoteFormFooter = ({ content }: Props) => {
  const { isMobile } = useDeviceWidth();
  const { classes } = useStyles();
  const { legalLinks, copyrightText, textColor } = content?.fields || {};
  return (
    <div
      className={classes.footer}
      style={{
        color: textColor,
      }}
    >
      <div className={classes.legal}>
        {legalLinks?.fields?.links?.map((legalLink, index) => {
          const linkTarget = openLinkCurrentTab(legalLink.fields.url)
            ? ''
            : '_blank';
          const linkRef = openLinkCurrentTab(legalLink.fields.url)
            ? ''
            : 'noopener noreferrer';
          return (
            <span key={legalLink.sys.id}>
              <a
                href={legalLink.fields.url}
                target={linkTarget}
                rel={linkRef}
                className={classes.link}
                onClick={() => {
                  trackEvents({
                    event: 'Legal link click',
                    click_text: legalLink.fields.text,
                  });
                }}
              >
                {legalLink.fields.text}
              </a>
              <span>
                {index !== legalLinks.fields.links.length - 1 && ' | '}
              </span>
            </span>
          );
        })}
        {!isMobile && (
          <span className={classes.copyright}> | {copyrightText}</span>
        )}
      </div>
      {isMobile && <p className={classes.copyright}>{copyrightText}</p>}
    </div>
  );
};

export default InteractiveQuoteFormFooter;
